import { render, staticRenderFns } from "./m-task-card.vue?vue&type=template&id=649225f6&"
import script from "./m-task-card.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-task-card.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-task-card.vue?vue&type=style&index=0&id=649225f6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports